export const FED_STANDARD_CODE_FILTER = 'fedStandardCode';
export const VEHICLE_GROUP_FILTER = 'vehicleGroup';
export const VEHICLE_TYPE_FILTER = 'vehicleType';
export const FEDERAL_STANDARDS_HIERARCHY = 'federalStandardsHierarchy';
